import classNames from 'classnames';
import PropTypes from 'prop-types';

const StatusList = ({ className }) => {
  return (
    <svg
      className={classNames('status-list-icon', className)}
      width='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.7639 8.5H19C19.5523 8.5 20 8.05228 20 7.5C20 6.94772 19.5523 6.5 19 6.5H15C15 7.26835 15.2889 7.96924 15.7639 8.5ZM13.416 8.5C13.1484 7.88754 13 7.2111 13 6.5H5C4.44772 6.5 4 6.94772 4 7.5C4 8.05228 4.44772 8.5 5 8.5H13.416ZM5 11.5C4.44772 11.5 4 11.9477 4 12.5C4 13.0523 4.44772 13.5 5 13.5H19C19.5523 13.5 20 13.0523 20 12.5C20 11.9477 19.5523 11.5 19 11.5H18H5ZM5 16.5C4.44772 16.5 4 16.9477 4 17.5C4 18.0523 4.44772 18.5 5 18.5H19C19.5523 18.5 20 18.0523 20 17.5C20 16.9477 19.5523 16.5 19 16.5H5Z'
        fill='currentColor'
      />
      <circle cx='18' cy='6.5' r='3' fill='currentColor' />
    </svg>
  );
};

StatusList.propTypes = {
  className: PropTypes.string,
};

export default StatusList;
